/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
// import { motion } from "framer-motion";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import Login from "../../sections/Login/Login";
import { SignUp } from "../../sections/SignUp/SignUp";
import MainButton from "../common/MainButton/MainButton";
import SideBarDrawer from "./SideBarDrawer";
import Avtar from "../../assets/img/default-image.jpg";
import useClickOutside from "../../Hooks/useClickOutside";
import NavBar from "./Navbar";
import AuxiliaryText from "../common/Typography/AuxiliaryText";
import SearchField from "../common/SearchInput/SearchField";
import TextField from "../common/InputField/TextFiled";
import InteractiveText from "../common/Typography/InteractiveText";
import SpecialText from "../common/Typography/SpecialText";
import AuthButtons from '../common/AuthButtons/AuthButtons';
import { useSelector, useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import QuoteRequestForm from '../QuoteRequestForm/QuoteRequestForm';
import { useLoginActionService, LOGIN_SCENARIOS } from '../../services/LoginActionService';
import Paragraph from "../common/Typography/Paragraph";
import { useHeaderDropdownData } from "./HeaderDropdownData";
import { HeaderDropdownRenderer } from "./DropdownRenderer";
import Pro from "../common/Tags/Pro";
import './header.css';

const Header = ({ isSellerDashboard }) => {
  const [listOpen, setListOpen] = useState(false);
  const [postingOpen, setPostingOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [settings, setSettings] = useState(false);
  const [notificationsAlerts, setNotificationsAlerts] = useState(false);
  const [searchDropdownOpen, setSearchDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchAnimating, setIsSearchAnimating] = useState(false);
  const [scrolledVersion, setScrolledVersion] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSidebarOpen, setIsSideBarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [quoteRequestOpen, setQuoteRequestOpen] = useState(false);
  const [pendingQuoteRequest, setPendingQuoteRequest] = useState(false);
  // Add missing state variables
  const [subsOpen, setSubsOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [inboxOpen, setInboxOpen] = useState(false);
  const { profilePicture, userPlan } = useSelector((state) => state.user);
  const isPro = userPlan?.plan?.name?.toLowerCase() === 'pro';
  const dispatch = useDispatch();
  const loginActionService = useLoginActionService();
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const responsive = () => {
      setIsMobile(window.matchMedia("(max-width: 1023px)").matches);
    };
    const event = () => {
      setScrolledVersion(() => {
        if (window.scrollY <= 0) {
          return false;
        }
        return true;
      });
    };

    responsive();
    document.addEventListener("scroll", event);
    window.addEventListener("resize", responsive);
    return () => {
      document.removeEventListener("scroll", event);
      window.removeEventListener("resize", responsive);
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    };
  }, []);

  const location = useLocation();

  // Pages that show only cross in header (no logo)
  const showCrossOnlyInHeader =
    location.pathname.includes("/business-dashboard/posts/create-post") ||
    location.pathname.includes("/business-dashboard/tickets/create") ||
    /^\/business-dashboard\/tickets(\/[^/]+)?$/.test(location.pathname) ||
    location.pathname === "/business-dashboard/posts/published" ||
    location.pathname === "/business-dashboard/posts/drafts" ||
    location.pathname === "/business-dashboard/posts/flagged" ||
    location.pathname === "/business-dashboard/posts/bin" ||
    location.pathname === "/business-dashboard/inbox/chats" ||
    location.pathname === "/business-dashboard/inbox/quotes" ||
    location.pathname === "/business-dashboard/inbox/deleted" ||
    location.pathname === "/business-dashboard/inbox/blocked" ||
    location.pathname === "/business-dashboard/subscriptions/billing-details" ||
    location.pathname === "/business-dashboard/inbox/reviews" ||
    location.pathname === "/business-dashboard/settings/manage-portfolio";

  const { auth, setAuth } = useAuth();
  const [SignUpState, setSignUpState] = useState(false);
  const [SignIn, setSignIn] = useState(false);

  const [IsDropDownOpen, setDropDown] = useState(false);
  const [openSubmenuKey, setOpenSubmenuKey] = useState(null);
  const { id: userId } = auth?.user ?? "";
  const ref = useRef(null);
  const notificationsRef = useRef(null);

  // Get dropdown data (matches sidebar menu structure)
  const dropdownData = useHeaderDropdownData({
    auth,
    setAuth,
    IsDropDownOpen,
    setDropDown,
    setOpenSubmenuKey,
    toggleDrawer,
  });
  const searchDropdownRef = useRef(null);
  const searchIconRef = useRef(null);
  
  // Handle click outside for general dropdowns
  useClickOutside(ref, () => {
    setSettings(false);
    setDropDown(false);
    setOpenSubmenuKey(null);
    setListOpen(false);
    setPostingOpen(false);
    setSidebarOpen(false);
    setHelpOpen(false);
    setInboxOpen(false);
    setSubsOpen(false);
    // Don't close search dropdown here - it has its own handler
  });
  
  // Handle click outside specifically for notifications dropdown
  useClickOutside(notificationsRef, () => {
    setNotificationsAlerts(false);
  });

  // Handle click outside for search dropdown
  useClickOutside([searchDropdownRef, searchIconRef], () => {
    if (searchDropdownOpen && !isSearchAnimating) {
      setIsSearchAnimating(true);
      setTimeout(() => {
        setSearchDropdownOpen(false);
        setIsSearchAnimating(false);
      }, 300);
    }
  });

  // Handle search functionality
  const handleSearch = (query) => {
    if (query.trim()) {
      // Navigate to category page with the search query
      const servicePath = `/category/${query.toLowerCase()}`;
      window.location.href = servicePath;
      
      setSearchDropdownOpen(false);
      setSearchQuery("");
    }
  };

  // Handle automatic quote request form opening after login redirect
  useEffect(() => {
    if (auth?.user && pendingQuoteRequest) {
      setQuoteRequestOpen(true);
      setPendingQuoteRequest(false);
    }
  }, [auth?.user, pendingQuoteRequest]);

  // Handle Get free Quotes button click
  const handleRequestQuote = () => {
    console.log('handleRequestQuote called');
    console.log('Current auth state:', auth);
    console.log('Current path:', location.pathname + location.search);
    loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.QUOTE_REQUEST.id, {
      setSignIn,
      currentPath: location.pathname + location.search,
      auth,
      setPopupOpen: setQuoteRequestOpen
    });
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [isOpen]);

  return (
    <>
      <Login
        SignIn={SignIn}
        setSignIn={setSignIn}
        SignUpState={SignUpState}
        setSignUpState={setSignUpState}
        onLoginSuccess={() => {
          console.log('onLoginSuccess called in Header component');
          console.log('auth state:', auth);
          // Check for pending scenarios after login
          const hasPendingScenario = loginActionService.checkAndHandlePendingScenario(setQuoteRequestOpen);
          
          // Close login modal after handling pending scenario to prevent blink
          if (hasPendingScenario) {
            // If there's a pending scenario, close login modal after opening the popup
            setTimeout(() => {
              setSignIn(false);
            }, 150); // Delay to ensure quote popup opens first, then login modal closes
          } else {
            // If no pending scenario, close login modal immediately
            setSignIn(false);
          }
        }}
      />
      <SignUp
        SignUpState={SignUpState}
        setSignUpState={setSignUpState}
        SignIn={SignIn}
        setSignIn={setSignIn}
      />
      
      {/* Quote Request Form Popup */}
      <QuoteRequestForm
        isOpen={quoteRequestOpen}
        onClose={() => setQuoteRequestOpen(false)}
      />

      {/* scrolledVersion={scrolledVersion || isOpen} */}
      <HeaderContainer>
        <div
          className={`
          ${
            isOpen
              ? "bg-pastalblue "
              : location.pathname.includes("dashboard")
              ? "bg-white"
              : location.pathname === "/pricing" ||
                location.pathname === "/business-support-centre" ||
                location.pathname === "/pro"
              ? "bg-transparent"
              : location.pathname == "/" || location.pathname === "/" ||
                location.pathname === "/customer-support-centre" ||
                location.pathname.includes("/services-guide/")
              ? "bg-transparent text-white"
              : "bg-pastalblue text-offblack"
          } 
          `}
        >
          <div
            className={
              isSellerDashboard
                ? `${location.pathname === "/business-dashboard/dashboard" ? "tp-container" : (location.pathname === "/business-dashboard/posts/drafts" || location.pathname === "/business-dashboard/posts/published" || location.pathname === "/business-dashboard/posts/bin" || location.pathname === "/business-dashboard/posts/flagged" || location.pathname === "/business-dashboard/settings/manage-portfolio") ? "tp-container" : (location.pathname === "/business-dashboard/inbox/chats" || location.pathname === "/business-dashboard/inbox/quotes" || location.pathname === "/business-dashboard/inbox/deleted" || location.pathname === "/business-dashboard/inbox/blocked" || location.pathname === "/business-dashboard/inbox/reviews" || location.pathname.includes("/business-dashboard/posts/create-post") || location.pathname.startsWith("/business-dashboard/tickets") || location.pathname === "/business-dashboard/subscriptions/billing-details") ? "tp-container-small" : "tp-container-main"} flex items-center justify-between mx-auto h-[80px]`
                : location.pathname.includes("/NotHelpCentre")
                ? "flex items-center justify-between w-full max-w-3xl mx-auto h-[80px]"
                : location.pathname.includes("/poster-profile")
                ? "tp-container flex items-center justify-between mx-auto h-[80px]"
                : location.pathname === "/category" ||
                    location.pathname.startsWith("/category/")
                  ? "tp-container-fluid flex items-center justify-between mx-auto h-[80px] w-full"
                  : "tp-container-home flex items-center justify-between mx-auto h-[80px]"
            }
          >
            {!showCrossOnlyInHeader && (
              <div className={`${location.pathname.includes("business-dashboard") ? "mr-12" : ""}`} onClick={() => setIsOpen(false)}>
                <Link to="/">
                  <img
                    className="w-[60px] h-[25px] sm:w-[65px] sm:h-[28px] lg:w-[70px] lg:h-[30px] cursor-pointer"
                    src={require("../../assets/img/trades-poster.png")}
                    alt="trade-poster"
                    onClick={() => window.scrollTo(0, 0)}
                  />
                </Link>
              </div>
            )}

            {location.pathname === "/business-dashboard/dashboard" ? (
              <div>
                <SearchField placeholder={"Search"} />
              </div>
              ) : null}

            <div className="ml-auto">
              {!location.pathname.includes("/NotHelpCentre") && (
                <>
                  <div
                    className={" items-center hidden lg:flex"
                    }
                  >
                    {!location.pathname.includes("business-dashboard") && (
                      <NavBar
                        scrolledVersion={scrolledVersion}
                        SignInState={SignIn}
                        setSignIn={setSignIn}
                        hideCategoriesAndPricing={Boolean(auth?.user)}
                      />
                    )}
                    
                    {/* Get free Quotes button after navigation for logged-in users (not on dashboard) */}
                    {/* {auth?.user && !location.pathname.includes("business-dashboard") && (
                      <div className="mr-8">
                        <MainButton
                          variant="large"
                          onClick={handleRequestQuote}
                        >
                          Get free Quotes
                        </MainButton>
                      </div>
                    )} */}
                    
                    <div className="flex items-center">
                      {!auth?.user ? (
                        <div className="flex items-center">
                          <AuthButtons
                            variant="desktop"
                            onSignIn={() => setSignIn(!SignIn)}
                            onSignUp={() => setSignUpState(!SignUpState)}
                            onRequestQuote={handleRequestQuote}
                            showRequestQuote={true}
                            currentPath={location.pathname + location.search}
                            auth={auth}
                          />
                        </div>
                      ) : (
                        <>
                        {/* Show cross icon for create post page and other specific pages */}
                        {showCrossOnlyInHeader ? (
                          <div className="flex items-center">
                            <button
                              onClick={() => {
                                const isViewingMessage = new URLSearchParams(location.search).get('view') === 'message';
                                const isInboxPage = location.pathname === "/business-dashboard/inbox/chats" || location.pathname === "/business-dashboard/inbox/quotes";
                                if (isInboxPage && isViewingMessage) {
                                  navigate(location.pathname);
                                } else {
                                  navigate("/business-dashboard/dashboard");
                                }
                              }}
                              className="flex items-center justify-center w-8 h-8 rounded-full transition-colors duration-200"
                            >
                              <i className="fi fi-rs-cross text-base text-offblack cursor-pointer"></i>
                            </button>
                          </div>
                        ) : (
                            <>
                              <div className="flex items-center gap-10">

                                
                                <ul className={`${location.pathname.includes("business-dashboard") ? "" : "ml-12"} flex items-center gap-5`}>
                                  {/* Search Section - only visible on non-dashboard pages */}
                                  {/* {!location.pathname.includes("business-dashboard") && (
                                    <li className="hidden lg:block relative">
                                      <div className="flex items-center">
                                        <div 
                                          ref={searchDropdownRef}
                                          className="relative z-10 rounded-full bg-white text-offblack shadow-2xl mr-4 transition-all duration-300 ease-out opacity-100 scale-100 overflow-hidden"
                                          style={{
                                            animation: isSearchAnimating ? 'slideOutToRight 0.3s ease-out' : 'slideInFromLeft 0.3s ease-out'
                                          }}
                                        >
                                          <div className="px-0">
                                            <TextField
                                              variant="exsmall"
                                              placeholder="Search for services, businesses..."
                                              value={searchQuery}
                                              className={"rounded-full"}
                                              onChange={(e) => setSearchQuery(e.target.value)}
                                              onKeyDown={(e) => {
                                                if (e.key === 'Enter' && searchQuery.trim()) {
                                                  handleSearch(searchQuery);
                                                }
                                              }}
                                              autoFocus
                                            />
                                          </div>
                                        </div>
                                        
                                        <i
                                          ref={searchIconRef}
                                          className={`fi fi-rs-search text-base cursor-pointer flex items-center justify-center hover:text-primaryblue transition-colors duration-200 z-20 relative ${
                                            searchDropdownOpen ? 'text-primaryblue' : ''
                                          }`}
                                          onClick={() => {
                                            if (searchDropdownOpen) {
                                              setIsSearchAnimating(true);
                                              setTimeout(() => {
                                                setSearchDropdownOpen(false);
                                                setIsSearchAnimating(false);
                                              }, 300);
                                            } else {
                                              setSearchDropdownOpen(true);
                                              setIsSearchAnimating(false);
                                            }
                                          }}
                                        ></i>
                                      </div>
                                    </li>
                                  )} */}
                                  
                                  {/* Bell Icon */}
                                  <li
                                    className="cursor-pointer hover:bg-transparent hidden lg:block relative"
                                    ref={ref}
                                  >
                                    <i
                                      className="fi fi-rs-bell text-base cursor-pointer flex items-center justify-center"
                                      onClick={() =>
                                        setNotificationsAlerts(
                                          !notificationsAlerts
                                        )
                                      }
                                    ></i>
                                    {/* Notification Badge */}
                                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></div>
                                    {notificationsAlerts && (
                                      <div 
                                        ref={notificationsRef}
                                        className="absolute z-10 w-[350px] origin-top-right rounded-xl bg-white text-offblack pt-5 pb-10 mt-3 -right-14 shadow-2xl"
                                      >
                                        <div
                                          class="w-0 h-0 border-l-[10px] border-l-transparent border-b-[15px] border-b-white border-r-[10px] border-r-transparent absolute left-[275px] -mt-8"
                                        ></div>
                                        {/* Heading */}
                                        <div className="flex items-center justify-between px-5 mb-5">
                                          <AuxiliaryText variant={"MenuDropdown"} className={"font-semibold"}>
                                            Notifications
                                          </AuxiliaryText>
                                          {/* <Link
                                            to={
                                              "/business-dashboard/inbox/notifications"
                                            }
                                            onClick={() => setNotificationsAlerts(false)}
                                          >
                                            <InteractiveText
                                              variant={"ActionLink"}
                                              className={"text-primaryblue"}
                                            >
                                              View all
                                            </InteractiveText>
                                          </Link> */}
                                        </div>

                                        {/* Notifications list */}
                                        <div className="border-t border-t-lightgray mx-5">
                                          <div className="border-b border-b-lightgray py-3 relative">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-x-2">
                                                <img
                                                  src={profilePicture || Avtar}
                                                  className="avatar-extra-small object-cover"
                                                />
                                                <AuxiliaryText
                                                  variant={"MenuDropdown"}
                                                >
                                                  Trades poster
                                                </AuxiliaryText>
                                              </div>
                                              <div className="flex items-center gap-2">
                                                <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                                                <SpecialText
                                                  variant={"Date"}
                                                  className={"text-mediumgray"}
                                                >
                                                  1 minute ago
                                                </SpecialText>
                                              </div>
                                            </div>
                                            <AuxiliaryText
                                              variant={"SubMenuDropdown"}
                                              className={
                                                "h-[20px] overflow-hidden text-ellipsis mt-2"
                                              }
                                            >
                                              Ensure seamless transactions and
                                              keep your business running
                                              smoothly with our straightforward
                                              billing section. Add/ remove
                                              payment methods, track and
                                              maintain record of all your
                                              pricing plans transactions with
                                              Trades Poster
                                            </AuxiliaryText>
                                          </div>
                                          <div className="border-b border-b-lightgray py-3 relative">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-x-2">
                                                <img
                                                  src={profilePicture || Avtar}
                                                  className="avatar-extra-small object-cover"
                                                />
                                                <AuxiliaryText
                                                  variant={"MenuDropdown"}
                                                >
                                                  Trades poster
                                                </AuxiliaryText>
                                              </div>
                                              <div className="flex items-center gap-2">
                                                <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                                                <SpecialText
                                                  variant={"Date"}
                                                  className={"text-mediumgray"}
                                                >
                                                  1 minute ago
                                                </SpecialText>
                                              </div>
                                            </div>
                                            <AuxiliaryText
                                              variant={"SubMenuDropdown"}
                                              className={
                                                "h-[20px] overflow-hidden text-ellipsis mt-2"
                                              }
                                            >
                                              Ensure seamless transactions and
                                              keep your business running
                                              smoothly with our straightforward
                                              billing section. Add/ remove
                                              payment methods, track and
                                              maintain record of all your
                                              pricing plans transactions with
                                              Trades Poster
                                            </AuxiliaryText>
                                          </div>
                                          <div className="border-b border-b-lightgray py-3 relative">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-x-2">
                                                <img
                                                  src={profilePicture || Avtar}
                                                  className="avatar-extra-small object-cover"
                                                />
                                                <AuxiliaryText
                                                  variant={"MenuDropdown"}
                                                >
                                                  Trades poster
                                                </AuxiliaryText>
                                              </div>
                                              <div className="flex items-center gap-2">
                                                <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                                                <SpecialText
                                                  variant={"Date"}
                                                  className={"text-mediumgray"}
                                                >
                                                  1 minute ago
                                                </SpecialText>
                                              </div>
                                            </div>
                                            <AuxiliaryText
                                              variant={"SubMenuDropdown"}
                                              className={
                                                "h-[20px] overflow-hidden text-ellipsis mt-2"
                                              }
                                            >
                                              Ensure seamless transactions and
                                              keep your business running
                                              smoothly with our straightforward
                                              billing section. Add/ remove
                                              payment methods, track and
                                              maintain record of all your
                                              pricing plans transactions with
                                              Trades Poster
                                            </AuxiliaryText>
                                          </div>
                                          <div className="border-b border-b-lightgray py-3 relative">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-x-2">
                                                <img
                                                  src={profilePicture || Avtar}
                                                  className="avatar-extra-small object-cover"
                                                />
                                                <AuxiliaryText
                                                  variant={"MenuDropdown"}
                                                >
                                                  Trades poster
                                                </AuxiliaryText>
                                              </div>
                                              <div className="flex items-center gap-2">
                                                <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                                                <SpecialText
                                                  variant={"Date"}
                                                  className={"text-mediumgray"}
                                                >
                                                  1 minute ago
                                                </SpecialText>
                                              </div>
                                            </div>
                                            <AuxiliaryText
                                              variant={"SubMenuDropdown"}
                                              className={
                                                "h-[20px] overflow-hidden text-ellipsis mt-2"
                                              }
                                            >
                                              Ensure seamless transactions and
                                              keep your business running
                                              smoothly with our straightforward
                                              billing section. Add/ remove
                                              payment methods, track and
                                              maintain record of all your
                                              pricing plans transactions with
                                              Trades Poster
                                            </AuxiliaryText>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </li>
                                  <li className="cursor-pointer hover:bg-transparent hidden lg:block relative">
                                    <Link
                                      to={"/business-dashboard/inbox/chats"}
                                    >
                                      <i className="fi fi-rs-comment-alt-dots text-base flex items-center justify-center"></i>
                                    </Link>
                                    {/* Message Notification Badge */}
                                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></div>
                                  </li>
                                </ul>
                                {location.pathname.includes("business-dashboard") ? (
                                <div ref={ref} className="relative">
                                  <div className="relative inline-block">
                                    <button
                                      onClick={() => setDropDown(!IsDropDownOpen)}
                                      type="button"
                                      className="flex max-w-xs items-center rounded-full bg-lightgray-800 text-sm"
                                      id="user-menu-button"
                                      aria-expanded="false"
                                      aria-haspopup="true"
                                    >
                                      <span className="sr-only">
                                        Open user menu
                                      </span>
                                      <img
                                        className="avatar-small object-cover"
                                        src={profilePicture || Avtar}
                                        alt="Profile"
                                      />
                                    </button>
                                    {isPro && (
                                      <div className="absolute -bottom-0.5 left-1/2 -translate-x-1/2">
                                        <Pro className="bg-primaryblue text-white" />
                                      </div>
                                    )}
                                  </div>
                                  {IsDropDownOpen && (
                                    <div
                                      className="absolute right-0 z-30 mt-2 w-60 origin-top-right rounded-xl bg-white text-offblack px-6 py-5 shadow-lg max-h-[80vh] overflow-y-auto"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="user-menu-button"
                                      tabIndex={-1}
                                    >
                                      {dropdownData.map((item, index) => (
                                        <div key={index}>
                                          {item.type === "link" ? (
                                            <Link
                                              to={item.link}
                                              className={`block py-2 hover:text-primaryblue ease-in-out w-full ${item.badge ? "flex items-center gap-2" : ""}`}
                                              role="menuitem"
                                              tabIndex={-1}
                                              onClick={item.onClick}
                                            >
                                              <AuxiliaryText variant={"MenuDropdown"}>
                                                {item.label}
                                              </AuxiliaryText>
                                              {item.badge && (
                                                <span className="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[11px] min-w-5 h-5 px-1 leading-none">
                                                  {item.badge}
                                                </span>
                                              )}
                                            </Link>
                                          ) : item.type === "dropdown" ? (
                                            <>
                                              <button
                                                onClick={item.onClick}
                                                className="flex justify-between py-2 hover:text-primaryblue ease-in-out w-full my-1 w-full text-left"
                                              >
                                                <AuxiliaryText variant={"MenuDropdown"}>
                                                  {item.label}
                                                </AuxiliaryText>
                                                <i className={`fi fi-rs-angle-down text-sm text-offblack flex-shrink-0 transition-transform ${openSubmenuKey === item.key ? "rotate-180" : ""}`}></i>
                                              </button>
                                              {openSubmenuKey === item.key && item.subMenu && (
                                                <ul className="text-start px-4">
                                                  {item.subMenu.map((sub, subIndex) => (
                                                    <li key={subIndex}>
                                                      <Link
                                                        to={sub.link}
                                                        onClick={sub.onClick}
                                                        className="block py-2 hover:text-primaryblue ease-in-out w-full my-1"
                                                      >
                                                        <AuxiliaryText variant={"SubMenuDropdown"}>
                                                          {sub.label}
                                                        </AuxiliaryText>
                                                      </Link>
                                                    </li>
                                                  ))}
                                                </ul>
                                              )}
                                            </>
                                          ) : null}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                                ) : null}
                              </div>
                            </>
                          )}
                          {!location.pathname.includes("business-dashboard") ? (
                            <>
                              <div ref={ref} className="relative ml-10">
                                <div className="relative inline-block">
                                  <button
                                    onClick={() => setDropDown(!IsDropDownOpen)}
                                    type="button"
                                    className="flex max-w-xs items-center rounded-full bg-lightgray-800 text-sm"
                                    id="user-menu-button"
                                    aria-expanded="false"
                                    aria-haspopup="true"
                                  >
                                    <span className="sr-only">
                                      Open user menu
                                    </span>
                                    <img
                                      className="avatar-small object-cover"
                                      src={profilePicture || Avtar}
                                      alt="Profile"
                                    />
                                  </button>
                                  {isPro && (
                                    <div className="absolute -bottom-0.5 left-1/2 -translate-x-1/2">
                                      <Pro className="bg-primaryblue text-white" />
                                    </div>
                                  )}
                                </div>
                                {IsDropDownOpen && (
                                  <div
                                    className="absolute right-0 z-30 mt-2 w-60 origin-top-right rounded-xl bg-white text-offblack px-6 py-5 shadow-lg "
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="user-menu-button"
                                    tabIndex={-1}
                                  >
                                    {dropdownData.map((item, index) => (
                                      <div key={index}>
                                        {item.type === "link" ? (
                                          <Link
                                            to={item.link}
                                            className={`block py-2 hover:text-primaryblue ease-in-out w-full ${
                                              item.badge ? "flex items-center gap-2" : ""
                                            }`}
                                            role="menuitem"
                                            tabIndex={-1}
                                            onClick={item.onClick}
                                          >
                                            <AuxiliaryText variant={"MenuDropdown"}>
                                              {item.label}
                                            </AuxiliaryText>
                                            {item.badge && (
                                              <span className="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[11px] min-w-5 h-5 px-1 leading-none">
                                                {item.badge}
                                              </span>
                                            )}
                                          </Link>
                                        ) : item.type === "dropdown" ? (
                                          <>
                                            <button
                                              onClick={item.onClick}
                                              className="flex justify-between py-2 hover:text-primaryblue ease-in-out w-full my-1 w-full text-left"
                                            >
                                              <AuxiliaryText variant={"MenuDropdown"}>
                                                {item.label}
                                              </AuxiliaryText>
                                              <i className={`fi fi-rs-angle-down text-sm text-offblack flex-shrink-0 transition-transform ${openSubmenuKey === item.key ? "rotate-180" : ""}`}></i>
                                            </button>
                                            {openSubmenuKey === item.key && item.subMenu && (
                                              <HeaderDropdownRenderer items={item.subMenu} />
                                            )}
                                          </>
                                        ) : null}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </>
                          ) : null }
                          

                        </>
                      )}
                    </div>
                  </div>
                  {/* {!location?.pathname?.includes("SellerDashboard") ? ( */}
                  <div>
                    <button
                      onClick={toggleDrawer}
                      className="text-black lg:hidden"
                    >
                      {isOpen ? (
                        <>
                          <i className="fi fi-rs-cross text-base text-offblack"></i>
                        </>
                      ) : (
                        <>
                          <i
                            className={`${
                              location.pathname === "/" ||
                              location.pathname ===
                                "/business-support-centre" ||
                              location.pathname ===
                                "/customer-support-centre" ||
                              location.pathname.includes("/services-guide/")
                              // location.pathname === "/pricing" ||
                              // location.pathname.includes("/councils-regulations")
                                ? "fi fi-rs-bars-staggered text-[26px] text-white"
                                : "fi fi-rs-bars-staggered text-[26px] text-offblack"
                            } `}
                          ></i>
                        </>
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {isMobile && isOpen ? (
          <div
            // initial={{ x: "100%" }}
            // animate={{ x: "0%" }}
            // transition={{ type: "tween", duration: 0.7 }}
            className={
              !auth?.user
                ? "bg-pastalblue h-[calc(100vh_-_80px)] pb-6 pt-28 fixed overflow-y-auto w-[100vw] z-10 top-[80px] left-0 block lg:hidden overflow-hidden"
                : "bg-pastalblue h-[calc(100vh_-_80px)] pt-10 fixed z-10 top-[80px] left-0 overflow-y-auto w-[100vw] pb-32 block lg:hidden overflow-hidden"
            }
          >
            {!auth?.user ? (
              <>
                <NavBar
                  isMobile={isMobile}
                  toggleDrawer={toggleDrawer}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  SignUpState={SignUpState}
                  setSignUpState={setSignUpState}
                  auth={auth}
                  setAuth={setAuth}
                  setSignIn={setSignIn}
                  hideCategoriesAndPricing={false}
                />
              </>
            ) : (
              <>
                <SideBarDrawer
                  isMobile={isMobile}
                  toggleDrawer={() => setIsSideBarOpen(!isSidebarOpen)}
                  isOpen={isSidebarOpen}
                  setIsOpen={setIsSideBarOpen}
                  SignUpState={SignUpState}
                  setSignUpState={setSignUpState}
                  auth={auth}
                  setAuth={setAuth}
                  close={() => setIsOpen(!isOpen)}
                />
              </>
            )}
          </div>
        ) : (
          ""
        )}
        {/* {isMobile &&
        isSidebarOpen &&
        location?.pathname?.includes("SellerDashboard") ? (
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: "0%" }}
            transition={{ type: "tween", duration: 0.7 }}
            className={
              !auth?.user
                ? "hidden"
                : "bg-white h-[calc(100vh_-_103px)] px-3 py-6 fixed z-10  top-[85px] left-0 overflow-y-auto w-[100vw] pb-32 md:hidden"
            }
          >
            <SideBarDrawer
              isMobile={isMobile}
              toggleDrawer={() => setIsSideBarOpen(!isSidebarOpen)}
              isOpen={isSidebarOpen}
              setIsOpen={setIsSideBarOpen}
              SignUpState={SignUpState}
              setSignUpState={setSignUpState}
              auth={auth}
              setAuth={setAuth}
              close={()=> setIsSideBarOpen(!isSidebarOpen)}
            />
          </motion.div>
        ) : (
          ""
        )} */}
      </HeaderContainer>
    </>
  );
};

const HeaderContainer = ({ scrolledVersion, isMobile, children }) => {
  const location = useLocation();
  const isSellerDashboard = location.pathname.includes("business-dashboard");
  if (!isSellerDashboard) {
    return (
      <div
        // initial={{ y: "-100%" }}
        // animate={{ y: "0%" }}
        // transition={{ type: "tween" }}
        className={
          location.pathname === "/"
            ? "absolute bg-transparent top-0 w-full z-40"
            : "absolute bg-transparent top-0 w-full z-40"
        }
      >
        {children}
      </div>
    );
  }
  return (
    <div
      className={`${isSellerDashboard ? "" : "absolute top-0"} w-full z-40 ${
        isMobile ? "bg-white" : "bg-transparent"
      }`}
    >
      {children}
    </div>
  );
};

export default Header;
